export default __webpack_public_path__ + "static/gray-32b1f04c343d23643207450803ca2cb4.jpg";